import api from '../token';

export const AlterFamilia = async (dados) => {
  try {
    const response = await api.post('/alterFamilia', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};


